import SERVICE_URL from "../config/API_DATA";
import BaseConfiguration from "../config/base.js"
import HttpPost from "../http/httppost.js";
import Logger from './logger.js';
import { TRIP,CITIZEN,DATE_TIME_FORMAT } from "../util/constants.js";
import { formatDate } from "../util/date/dateFunctions.js"
import {
  LOG_TYPE,
  FILE_NAME 
} from "../config/API_DATA";
import {cloneData, cloneDeep} from "../util/util";
export default class HotelSearchResult {
  static buildRequest(pHotelSearchObj) {
    let returnValue = null;
    let retBody = this.formatSearchObject(pHotelSearchObj);


    try {
      let body = retBody

      returnValue = body;
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.API_HOTEL_SEARCH_RESULT,
        "error in building body for HotelSearchResult",
        err.toString(),
        "buildRequest",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
    return returnValue;
  }

  static async getResponse(pReqOptions) {
    let returnValue = null;
    try {
      returnValue = await HttpPost.makeHttpPostRequest(
        SERVICE_URL.HOTEL_SEARCH_RESULTS,
        pReqOptions
      );
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.API_HOTEL_SEARCH_RESULT,
        "error in getting Response from  HotelSearchResult ",
        err.toString(),
        "getResponse",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
    return returnValue;
  }

   ///to format a search object
   static formatSearchObject(pHotelSearchObj) {
    let retValue = null;
    try {
      if (BaseConfiguration.isDebug) console.log("formatSearchObject");

      let searchFormat = {
        request: {
            checkInDate: null,
            checkOutDate: null,
            roomCount: null,
            guestInfo: [],
            location: {
                cityCode: null,
                airportCode: null,
                longitude: null,
                latitude: null
            },
            currency: null,
            lang:'en'
        }
      };

      let guestObj ={
          adultCount: null,
          childCount: null,
          childAge:[]
      }
      if(pHotelSearchObj){
        searchFormat.request.checkInDate = formatDate(pHotelSearchObj.date.checkInDate,DATE_TIME_FORMAT.API_DATE_FORMAT);
        searchFormat.request.checkOutDate = formatDate(pHotelSearchObj.date.checkOutDate,DATE_TIME_FORMAT.API_DATE_FORMAT);
        searchFormat.request.roomCount = pHotelSearchObj.roomCount;
        searchFormat.request.location.cityCode = pHotelSearchObj.areaObj.cityName.code;
        searchFormat.request.location.airportCode = pHotelSearchObj.areaObj.airportCode;
        searchFormat.request.location.longitude = pHotelSearchObj.areaObj.longitude;
        searchFormat.request.location.latitude = pHotelSearchObj.areaObj.latitude;

      }
      if(pHotelSearchObj.guestList)
      {
          for (let i = 0; i < pHotelSearchObj.guestList.length; i++) {
            guestObj.childAge=[]
            guestObj.adultCount= pHotelSearchObj.guestList[i].adult;
            guestObj.childCount= pHotelSearchObj.guestList[i].child;
            guestObj.childAge.push(10);
            searchFormat.request.guestInfo.push(cloneData(guestObj))
          }
          // for (let j = 0; j < guestObj.child; j++) {
            
              
          // }
      }

      // searchFormat.request.guestInfo.adultCount = guestObj.adults;
      // searchFormat.request.guestInfo.childCount = guestObj.child;
      // searchFormat.request.guestInfo.childAge = guestObj.childage;
        if(pHotelSearchObj.currencyObj)
        {
      searchFormat.request.currency = pHotelSearchObj.currencyObj.currency_code.code;
        }
        
// searchFormat.request.currency ="SGD"
      retValue = searchFormat;
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.API_SEARCH_RESULT,
        "error while formating object",
        err.toString(),
        "formatSearchObject",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
    return retValue;
  }
}
